export const HEARTBEAT_SIGNAL = Buffer.from('❤️');
